export class GrausParentesco{
   
    id:number;
	nome:string;
	
}